// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#E2E2E2"
      d="M12 0C13.3297 5.99124 18.0088 10.6703 24 12C18.0088 13.3297 13.3297 18.0088 12 24C10.6703 18.0088 5.99124 13.3297 0 12C5.99124 10.6703 10.6703 5.99124 12 0Z"
    />
  </svg>
);
const IconStar2 = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconStar2;
